const Table = ({
  HeadComponent = () => {},
  BodyComponent = () => {},
  className,
}) => {
  return (
    <table className={`table table border-top ${className}`}>
      <thead>
        <HeadComponent />
      </thead>
      <tbody>
        <BodyComponent />
      </tbody>
    </table>
  )
}

export default Table
